import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

// Mismo patrón que crear proceso de GPP: padding de página, cabecera 18/600 con descripción
// en 14 terciario y el formulario en una tarjeta blanca de dos columnas
const JobOfferWizardStyled = styled.div`
  && {
    padding: 30px 60px;
  }

  .headerSection {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 900px;
    margin: 16px 0 24px;

    h2 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      line-height: 1.3;
      color: ${color.text.primary};
    }

    .description {
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.5;
      color: ${color.text.tertiary};
    }
  }

  .form-card {
    padding: 24px;
    background: ${color.background.default};
    border-radius: 6px;
    box-shadow: 0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06);
  }

  .form-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px 24px;

    @media (max-width: 900px) {
      grid-template-columns: 1fr;
    }
  }

  .form-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;

    label {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      color: ${color.text.label};
    }

    .input-container,
    .input-container input,
    textarea {
      width: 100%;
    }
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
  }
`

export default JobOfferWizardStyled
